<script lang="ts">
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import type { AlertAction } from '$shared/models/AlertAction';

  interface Props {
    alert: AlertAction;
    onalert?: (alert: AlertAction) => void;
  }

  let { alert, onalert }: Props = $props();

  const onClick = () => {
    onalert?.(alert);
  };
</script>

<div class="entity-alert">
  {#if alert && alert.label}
    <button data-cy="alert-label" class="warn-banner" onclick={onClick}>
      <div class="text">{alert.label}</div>
      {#if alert.action}
        <div class="separator">-</div>
        <div class="action">{alert.action}</div>
      {/if}
      <div class="icon"><Icon value="icon-chevron-right" /></div>
    </button>
  {/if}
</div>

<style>
  .warn-banner {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--yellow);
    padding: 8px 16px;
    border-radius: 2px 2px 0px 0px;
    position: relative;
  }
  .warn-banner:hover {
    background-color: var(--yellow-hover);
  }
  .warn-banner .separator {
    margin: 0 4px;
  }
  .warn-banner .action {
    text-decoration: underline;
  }

  .icon {
    position: absolute;
    top: 50%;
    right: 8px;
    transform: translate(0, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
